import { render } from "./ArtsBaccalaureateEVAU.vue?vue&type=template&id=798329fe"
import script from "./ArtsBaccalaureateEVAU.vue?vue&type=script&lang=js"
export * from "./ArtsBaccalaureateEVAU.vue?vue&type=script&lang=js"

import "./ArtsBaccalaureateEVAU.vue?vue&type=style&index=0&id=798329fe&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__